import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/contracts')({
  component: () => <Outlet />,
})
